import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

export const OverlayContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: ${COLORS.white};
  z-index: 15;
  border-radius: 15px;

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    min-height: 0;
  }
`

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
`
